'use strict';

/**
 * DO NOT USE
 * USE THEME IN REACT COMPONENT LIBRARY
 * react-components-library/src/hqo-theme-provider/hqo-theme.ts
 */
var defaultTheme = {
    colors: {
        $primary: '#257BAD',
        $secondary: '#7C7933',
        $white: '#FFFFFF',
        $greyDark: '#696E72',
        $greyLight: '#F6F7F8',
        $alertRed: '#EC003E',
        $backgroundBlur: '#2d3338',
        $sharedGreyDark: '#707070',
        $sharedGreyLight: '#F4F4F4',
        $adminPink: '#D52465',
        $transparent: 'transparent',
        $darkGrayishBlue: '#939ba2',
        $darkGreen: '#04623E',
        $darkRed: '#E62222',
        $darkOrange: '#E65722',
    },
};

exports.defaultTheme = defaultTheme;
